const GET_CLASSES = 'GET_CLASSES';
const GET_BRANCHES_BY_CLASS_ID = 'GET_BRANCHES_BY_CLASS_ID';
const GET_RECOMMEND_BOOK = 'GET_RECOMMEND_BOOK';
export default {
  GET_CLASSES,
  GET_BRANCHES_BY_CLASS_ID,
  GET_RECOMMEND_BOOK,
};
